import React from 'react'
import * as styles from './section-alternate-grid.module.scss';

import { GatsbyImage } from 'gatsby-plugin-image';

import HeadingLevel from '../../Shared/HeadingLevel/HeadingLevel';
import { RichText } from '../../Shared/RichText/RichText';
import ButtonPrimary from '../../Shared/ButtonPrimary/ButtonPrimary';

const SectionAlternateGrid = ({
    data
}) => {
    const {
        screenSize,
        alignment,
        content,
        desktopImage,
        headingLevel,
        imageSubTitle,
        title,
        textAlignment,
        triangle,
        buttonAlignment,
        buttonLink,
        box,
        imageSize,
        contentContainerSize,
        extraClasses
    } = data

    return (
        <div className={`${triangle && 'triangle'}`}>
            <div className={`container container-${screenSize} ${styles.container} alternate-grid  ${styles[box]} ${styles[extraClasses]}`}>
                <div className={`${styles.imageContainer} ${styles[alignment.toLowerCase()]}`} style={{ width: `${imageSize}%` }}>
                    <GatsbyImage
                        image={desktopImage.gatsbyImageData} alt={title || desktopImage.title}
                    />
                    {
                        imageSubTitle && <HeadingLevel title={imageSubTitle} headingLevel={null} extraClass={styles.imageSubTitle} />
                    }
                    {
                        buttonAlignment === 'image-section' && <div className={styles.button}>
                            <ButtonPrimary link={(buttonLink.target?.slug || buttonLink.slug)} text={buttonLink.title} extraClass={styles.bold} />
                        </div>
                    }
                </div>
                <div className={`${styles.contentContainer} ${styles[`text${textAlignment}`]}`} style={{ width: `${contentContainerSize ? contentContainerSize : '50'}%` }}>
                    {
                        title &&
                        <HeadingLevel title={title} headingLevel={headingLevel} extraClass={styles.heading} />
                    }
                    <div className={`${styles.content} recipe-space`}>
                        <RichText content={content} />
                    </div>
                    {
                        buttonAlignment === 'text-section' && <div className={styles.button}>
                            <ButtonPrimary link={(buttonLink.target?.slug || buttonLink.slug)} text={buttonLink.title} extraClass={styles.bold} />
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}

export default SectionAlternateGrid